var map = {
	"./Appachatti.jpeg": 27,
	"./Appakara12.jpeg": 28,
	"./Appakara5.jpg": 29,
	"./Appakara7.jpg": 30,
	"./Banali.jpg": 31,
	"./Chattukam-R.jpg": 32,
	"./Chattukam.jpeg": 33,
	"./Kayil.jpg": 34,
	"./PathiriKallu.jpg": 35,
	"./Uruli-L.jpeg": 36,
	"./Uruli-S.jpeg": 37,
	"./Uruli.jpg": 38,
	"./Varp-L.jpg": 39,
	"./Varp-M.jpg": 40,
	"./Varp-S.jpg": 41,
	"./bizpage-preview.png": 42,
	"./icon.png": 43,
	"./logo.png": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4;